import { useNavigate } from "react-router-dom";

import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import { IconButton } from "atoms/icon-button/IconButton";

type PageHeaderProps = {
  title: string;
};

export const PageHeader = ({ title }: PageHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-10 flex items-center justify-between bg-white pb-[5px] pr-4 pt-[calc(20px_+_env(safe-area-inset-top))] shadow">
      <IconButton
        size="small"
        style="iconOnly"
        svg={ChevronLeft}
        onClick={() => {
          navigate(-1);
        }}
      />
      <div className="text-sub2 uppercase">{title}</div>
      {/* Padding via component to match existing styling in other pages */}
      <div className="invisible w-11"></div>
    </div>
  );
};
